import { createSlice } from '@reduxjs/toolkit';

export const userIdentities = createSlice({
  name: 'IDENTITIES',
  initialState: {}, // state comes from preloadedState in the store and overwrites

  reducers: {
    updateIdentities(state, action) {
      const { lytics, visitorId } = action.payload;
      return {
        ...state,
        ...(lytics !== undefined && { lytics }), // The lytics identifier is requested from the host page
        ...(visitorId !== undefined && { visitorId }), // The internal visitorId is generated by the form
      };
    },
    setCheqData(state, action) {
      const { cheqData } = action.payload;
      return {
        ...state,
        ...(cheqData !== undefined && { cheqData }),
      };
    },
  },
});

const { actions, reducer } = userIdentities;

export const { updateIdentities, setCheqData } = actions;

export default reducer;
